import { render, staticRenderFns } from "./DadosSocios.vue?vue&type=template&id=63b7608a"
import script from "./DadosSocios.vue?vue&type=script&lang=js"
export * from "./DadosSocios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports